import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar  from './components/Navbar';
import Footer  from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home    from './pages/Home';
import Dogs    from './pages/Dogs';
import DogDetail from './pages/DogDetail';
import { Events, About, Donate, Contact, Memorial } from './pages/OtherPages';
import { Login, ForgotPassword, ResetPassword } from './pages/Auth';
import AdminLayout from './pages/admin/AdminLayout';
import './index.css';

// Protected route wrapper
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-center"><div className="spinner" /></div>;
  if (!user)   return <Navigate to="/admin" replace />;
  return children;
}

// Public layout (with Navbar + Footer)
function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main style={{ paddingTop: 0 }}>{children}</main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public pages */}
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/dogs" element={<PublicLayout><Dogs /></PublicLayout>} />
          <Route path="/dogs/:id" element={<PublicLayout><DogDetail /></PublicLayout>} />
          <Route path="/events" element={<PublicLayout><Events /></PublicLayout>} />
          <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
          <Route path="/donate" element={<PublicLayout><Donate /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          <Route path="/memorial" element={<PublicLayout><Memorial /></PublicLayout>} />

          {/* Auth pages (no Navbar/Footer) */}
          <Route path="/admin" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Admin panel (protected) */}
          <Route path="/admin/*" element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          } />

          {/* 404 */}
          <Route path="*" element={
            <PublicLayout>
              <div style={{ textAlign:'center', padding:'160px 24px' }}>
                <div style={{ fontSize:'4rem', marginBottom:16 }}>🐾</div>
                <h1 style={{ fontFamily:'var(--font-display)', fontSize:'2rem', color:'var(--navy)', marginBottom:8 }}>Page Not Found</h1>
                <p style={{ color:'var(--text-light)', marginBottom:24 }}>Looks like this page ran away!</p>
                <a href="/" className="btn btn-primary">Go Home</a>
              </div>
            </PublicLayout>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
